import React from "react";

export const NodeWrapper = ({children, bgColor = "#222138"}) => {

  return (
    <div 
      style={{
        padding: "0px", 
        paddingRight: "0px",
        paddingLeft: "0px",
        borderRadius: "0px",
        backgroundColor: bgColor,
        color: "white",  
        border: "1px solid #7371b5",      
      }}
    >
      {children}
    </div>
  )
}

